import { TDataset } from '../../../models/aibuilder/aibuilder';
import { TextTrainingSample } from './useTextModel';

export function buildTextTrainingSamples(dataset: TDataset): TextTrainingSample[] {
  const labels = dataset.labels || [];
  const samples = dataset.samples || [];
  const byId = new Map(labels.map((label) => [label.id, label.name]));
  return samples
    .filter((sample) => !sample.excluded && sample.content_text && sample.label_id && byId.get(sample.label_id))
    .map((sample) => ({ text: sample.content_text as string, label: byId.get(sample.label_id as number) as string }));
}
